<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('redeem_products')" icon="briefcase">
<!--      <app-default-button btn-class="btn btn-success mr-2"-->
<!--                          :title="$fieldTitle('add', 'product', true)"-->
<!--                          @click="openModal()"-->
<!--                          v-if="$can('create_crms')"-->
<!--      />-->
    </app-page-top-section>

    <app-table
        id="redeem-product-table"
        :options="options"
        :card-view="false"
        @reload="reloadShopTable"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

<!--    <app-shop-create-edit-modal-->
<!--        v-if="isModalActive"-->
<!--        v-model="isModalActive"-->
<!--        :selected-url="selectedUrl"-->
<!--        @close="isModalActive = false"-->
<!--    />-->

    <app-redeem-product-modal
        v-if="isModalActive"
        v-model="isModalActive"
        icon="gift"
        :data="productData"
        @close="isModalActive = false"
        modal-id="app-redeem-product-modal"
        @confirmed="confirmed('redeem-product-table')"
        @cancelled="cancelled"
    />

    <app-confirmation-modal
        v-if="confirmationModalActive"
        icon="trash-2"
        modal-id="app-confirmation-modal"
        @confirmed="confirmed('redeem-product-table')"
        @cancelled="cancelled"
    />

  </div>
</template>

<script>
// import PackageCreateEditModal from "./PackageCreateEditModal";

import RedeemProductModal from "./RedeemProductModal";
import RedeemProductMixin from "../../Mixins/RedeemProductMixin";
export default {
  name: "Redeem_Products",
  components: {RedeemProductModal},
  // components: {ShopCreateEditModal},
  mixins: [RedeemProductMixin],
  data() {
    return {
      productData: null,
      isModalActive: false,
      selectedUrl: '',
      confirmationModalActive: false,
    }
  },
  methods: {
    toggleModal() {
      this.isModalActive = true;
    },
    triggerActions(row, action, active) {
      if (action.name === 'redeem') {
        // this.selectedUrl = `${GET_ALL_LOCATIONS}/${row.id}`;
        this.productData = row;
        this.isModalActive =  true;
      }
      else {
        this.getAction(row, action, active)
      }

    },
  }
}
</script>
